import { createTheme, PaletteMode, PaletteOptions } from "@mui/material/styles";
import lightTheme from "./light.json";
import darkTheme from "./dark.json";
import customTheme from "./custom.json";

export const createAppTheme = (
  mode: PaletteMode,
  palette: PaletteOptions = { mode } as PaletteOptions
) => {
  const defaultPalette = palette.mode === "light" ? lightTheme : darkTheme;

  return createTheme({
    palette: {
      ...defaultPalette,
      ...palette,
      mode,
    },
  });
};
